import * as ACTION_TYPES from '../types';

let initialState = {
  supportList: [],
  support: {}
}

export default (state = initialState, action) => {
    switch (action.type) {

      case ACTION_TYPES.GET_SUPPORTS:
        return {...state, supportList: action.data };

      case ACTION_TYPES.DELETE_SUPPORT:
        let newList = state.supportList.filter(support => support._id !== action.id);
        return {...state, supportList: newList };

      case ACTION_TYPES.GET_SUPPORT_BY_ID:
        return {...state, support: action.data};

      case ACTION_TYPES.REQUEST:
        return {...state, loading: true };

      case ACTION_TYPES.DONE:
        return {...state, loading: false };

      case ACTION_TYPES.RESET_MATERIALS:
        return {...state, supportList: []};

      default:
        return state;
    }
  };